<template>
    <el-container class="transport-app">
       <el-container>
            <Aside />
            <el-main ref="keepalive">
                <TagsView :isShowItHelp="false" class="supplier-tagsview"/>
                <keep-alive :include="cachedViews">
                <router-view></router-view>
                </keep-alive>
                <warn-alert></warn-alert>
            </el-main>
         </el-container>
         <help-button></help-button>
    </el-container>
</template>
<script>
import TagsView from '@/components/lots/themes/tags_nav/index.vue';
import Aside from '@/components/lots/themes/aside/Aside';
import WarnAlert from './warnAlert/Index';
import HelpButton from '@/components/lots/floatHelp/HelpButton';
export default {
    components: {
        TagsView,
        Aside,
        WarnAlert,
        HelpButton
    },
    computed: {
        cachedViews() {
            return this.$store.state.cachedViews;
        },
        key() {
            return this.$route.fullPath;
        }
    }
};
</script>
<style lang="less">
@import "../styles/common.less";
.supplier-tagsview {
    min-width: 1000px;
}
</style>